/**
 * In-app browser tab titles while navigating routes.
 * Pattern: "Tools | ScaMatrix", "FAQ | ScaMatrix"
 *
 * Crawlers use server metadata (generateMetadata), not this helper.
 */
export function buildSegmentDocumentTitle(segment: string, siteName: string): string {
    return `${segment} | ${siteName}`;
}
